
import { Route, Routes, useLocation } from 'react-router-dom';
import { lazyImport } from '../utils/lazyImport';
import EmployerLogin from '../pages/login';

import SignUP from '../pages/employer/signUp';
import PrivacyPolicyComponent from '../pages/home/privacy-policy';
import TermsServiceComponent from '../pages/home/terms-service';

import { ROUTE_URL, PUBLIC_URL, ROLE } from '../constant/routeUrl'
import { removeItemFrmLocalStorage } from '../utils/genericUtilities';
import ContactUsComponent from '../pages/home/contact-us';
import CreatePasswordEmployerLogin from '../pages/create-password';
import PartTimerUserProfileComponent from '../pages/parttimer/user-profile';
import AccountVerifySuccessful from '../pages/create-password/successful';
import RejectionPaymentComponent from '../pages/parttimer/rejection-subscription';

const { EmployerLayout } = lazyImport(() => import('../components/layout/employerLayout'), 'EmployerLayout');
const { EmployeeLayoutHome } = lazyImport(() => import('../components/layout/index'), 'EmployeeLayoutHome');
const { EmployeeLayout } = lazyImport(() => import('../components/layout/jobSeekerLayout'), 'EmployeeLayout');

// ROUTE COMPONENT FUNCTION 
export default function RouteComponent() {

    const token = localStorage.getItem("token");
    const currentLocation = useLocation().pathname;
    const loginType = JSON.parse(localStorage.getItem('currentUser'));

    const publicValue = PUBLIC_URL.find((element) => element === currentLocation)

    if (publicValue && token) {
        loginType?.types[0] === 1 ? window.open(window.location.origin + '/dashboard', "_self") : window.open(window.location.origin + '/explorejobs?roles=employee', "_self")
    }


    if ((currentLocation.includes('/signup') || currentLocation.includes('/login')) && token) {

        loginType?.types[0] === 1 ? window.open(window.location.origin + '/dashboard', "_self") : window.open(window.location.origin + '/explorejobs?roles=employee', "_self")
    }

    if ((!currentLocation.includes('/signup')) && !token && ROUTE_URL.indexOf(currentLocation) >= 0) {

        window.open(window.location.origin + '/', "_self")
    }

    if (currentLocation === '/') {
        if (token) {
            // /explorejobs?roles=employee
            loginType?.types[0] === 1 ? window.open(window.location.origin + '/dashboard', "_self") : window.open(window.location.origin + '/explorejobs?roles=employee', "_self")
        }
    }
    if (loginType?.types[0] === 3) {
        removeItemFrmLocalStorage(['token', 'currentUser'])
    }


    return (
        <Routes>
            <Route path="/rejection-subscription" element={<RejectionPaymentComponent/>} />
            <Route path="/" element={<EmployeeLayoutHome pageTitle='home' />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyComponent />} />
            <Route path="/terms-conditions" element={<TermsServiceComponent />} />
            <Route path="/contact-us" element={<ContactUsComponent />} />

            <Route path="/login" element={<EmployerLogin />} />
            <Route path="/signup" element={<SignUP />} />
            <Route path="/employeesignin" element={<EmployeeLayout pageTitle='employeesignin' />} />
            {/* <Route path="/employeesubscription" element={<EmployeeLayout pageTitle='employeesubscription' />} /> */}
            {/* <Route path="/explorejobs" element={<PublicRoute  element={<ExplorePageComponent />} />}/> */}
            <Route path="/descriptionjob" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='descriptionjob' />} />
            <Route path="/viewCompany" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='viewCompany' />} />

            <Route path="/descriptionCertificate" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='descriptionCertificate' />} />

            <Route path="/employee-subscription" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='employee-subscription' />} />
            <Route path="/rejection-subscription" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='rejection-subscription' />} />
            <Route path="/parttimer-profile" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='parttimer-profile' />} />
            <Route path="/complete-profile" element={<PartTimerUserProfileComponent roles={[ROLE.PARTTIMER]} pageTitle='parttimer-profile' />} />
            <Route path="/complete-profile2" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='parttimer-profile' />} />

            <Route path="/dashboard" pageTitle={"dashboard"} element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='dashboard' />} />

            <Route path="/viewuser" pageTitle={"viewuser"} element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='viewuser' />} />


            {/* <Route
                path="/viewCompany"

                pageTitle={"viewCompany"}

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='viewCompany' />} /> */}


            <Route
                path="/payment"

                pageTitle={"payment"}

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='payment' />} />

            <Route
                path="/employeeview"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='employeeview' />} />



            <Route
                path="/jobPostPayment"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='jobPostPayment' />} />
            <Route
                path="/employersubscription"
                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='employersubscription' />} />
            <Route
                path="/employerSignupSubscription"
                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='employerSignupSubscription' />} />

            <Route
                path="/jobs/:status?/:subStatus?"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='jobs' />} />

            <Route
                path="/userProfile"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='userProfile' />} />


            <Route
                path="/postjob"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='postJob' />} />
            <Route
                path="/createCertification"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='createCertification' />} />
            <Route
                path="/viewCertificate"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='viewCertificate' />} />
            <Route
                path="/viewAppliedList"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='viewAppliedList' />} />
            <Route
                path="/viewjob"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='viewjob' />} />

            <Route
                path="/viewCandidate"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='viewCandidate' />} />

            <Route
                path="/viewCandidateShortTerm"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='viewCandidateShortTerm' />} />
            <Route
                path="/billing"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='billing' />} />

            <Route path="/explorejobs" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='explorejobs' />} />

            {/* <Route path="/employee-subscription" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='employee-subscription' />} /> */}

            <Route path="/explore-certifications" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='explore-certifications' />} />
            <Route path="/company-registration" element={<EmployerLayout pageTitle='companyRegister' />} />
            <Route path="/company-registration-offer" element={<EmployerLayout pageTitle='companyRegisterBypass' />} />
            <Route path="/my-jobs" element={<EmployeeLayout roles={[ROLE.PARTTIMER]} pageTitle='myJobs' />} />
            {/* <NotFound /> */}
            <Route
                path="/certifications"

                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='certifications' />} />

            <Route
                path="/applied-list-certifications"
                element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='applied-list-certifications' />} />
            <Route path="/groups" element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='groups' />} />
            <Route path="/groups/view/:id?" element={<EmployerLayout roles={[ROLE.EMPLOYER]} pageTitle='groupsView' />} />

            <Route path="/account-verify" element={<CreatePasswordEmployerLogin />} />
            <Route path="/account-verify-successful" element={<AccountVerifySuccessful />} />

        </Routes>
    )
}

